var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 -6.829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.817,55.9c-.245-.041-.637-.078-1.091-.123-2.5-.242-4.783-.556-5.222-1.725a1.828,1.828,0,0,1,.464-1.793c.365-.5.484-.726.3-1.043a2.036,2.036,0,0,0-.856-.522c-.692-.3-1.629-.712-1.684-1.807H3.852L0,57.9H15.609A3.281,3.281,0,0,0,12.817,55.9Z",
    transform: "translate(0 -30.54)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.075,49.814l-2,3.2a.377.377,0,0,1-.324.181h0a.386.386,0,0,1-.327-.187L32.945,48.86H25.2c.048.549.5.791,1.22,1.1a2.439,2.439,0,0,1,1.21.839,1.613,1.613,0,0,1-.337,1.882c-.314.436-.5.723-.368,1.074.307.818,3.191,1.1,4.578,1.231.47.044.873.085,1.145.13a3.911,3.911,0,0,1,3.467,2.751h5.4Z",
    transform: "translate(-19.705 -30.516)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.43,23.91h0a1.257,1.257,0,0,0,1.258-1.258A1.256,1.256,0,1,0,69.43,23.91Z",
    transform: "translate(-53.3 -9.04)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.179,16.039l1.016,1.7a.026.026,0,0,1,.007.014l2.267,3.8,3.446-5.512a.426.426,0,0,1,.034-.068,4.012,4.012,0,0,0-3.392-6.153H59.55a4.025,4.025,0,0,0-4.019,4.012,3.984,3.984,0,0,0,.614,2.13.425.425,0,0,1,.034.068Zm3.371-4.452a2.027,2.027,0,0,1,1.432,3.46,2.006,2.006,0,0,1-1.428.59h0a2.025,2.025,0,0,1,0-4.05Z",
    transform: "translate(-43.417 0)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMap);
export default __webpack_public_path__ + "static/media/Icon-map.925fcba0.svg";
export { ForwardRef as ReactComponent };